$(document).on("shards", function(evt, shards) {
	console.log('have shards', shards);
    for (var selector in shards) {
        var html = shards[selector];
        $(selector).html(html).trigger('bless');
    }
});
